<template>
  <button type="button" class="button" @click="$emit('click')">
    <span class="interesting">{{want ? '' : ''}}</span>
  </button>
</template>

<script>
export default {
  props: {
    want: {
      type: Boolean
    },
  },
};
</script>

<style scoped>
.interesting {
  font-family: "EBI-Common";
  font-size: 18px;
}

button {
  display: flex;
  align-items: center;
  padding: 3px 5px;
  height: 26px;
  width: 26px;
}
</style>